import noodleApiClient, { ApiDefinition } from '@noodleApi';
import buildPath from '@tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/products/{creatorSlug}/{productSlug}/messages/{messageId}/tags';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['POST'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const handleBroadcastTags = async ({ creatorSlug, productSlug, messageId, ...body }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { creatorSlug, messageId, productSlug });
  const data = await noodleApiClient.post(path, {...body});
  return data.data;
};

export default handleBroadcastTags;